import { type ControlsPayload } from './types';

export const PAGE_SIZE_OPTIONS = [
	{ label: '20', value: 20 },
	{ label: '50', value: 50 },
	{ label: '100', value: 100 },
] as const;

export const SORT_DIRECTION = {
	ASC: 'ASC',
	DESC: 'DESC',
} as const;

export const PAGINATION_DIRECTION = {
	NEXT: 'NEXT',
	PREVIOUS: 'PREVIOUS',
} as const;

export const DEFAULT_CONTROLS_PAYLOAD: ControlsPayload = {
	page: 0,
	size: PAGE_SIZE_OPTIONS[0].value,
	sortBy: undefined,
	sortDirection: undefined,
	searchTerm: undefined,
	filters: {},
};
